<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.garantie.purchase-date.date_d_achat')}} </h1>
    <sav-fold-card v-model="open" class="mt-4" :close-button="false" :can-open="canOpen"  :id="$options.name">
        <template v-slot:close>
            <template v-if="selected">
                <div class="font-bold">
                    <div v-if="selected[0].value">{{selected[0].value}}</div>
                    <div v-else>{{$t('form.garantie.purchase-date.ne_sait_pas')}}</div>
                </div>
            </template>
        </template>
        <template v-slot:open>
            <sav-spinner v-if="loading" :size="10" />
            <sav-form v-if="data" :data-src="data" :callback="end" :id="$options.name" :skip="canSkip ? $t('form.garantie.purchase-date.ne_sait_pas') : null" />
        </template>
    </sav-fold-card>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'
import moment from 'moment'

export default {
    name: 'purchase-date',
    extends: FormCardExtension,

    computed: {
        canSkip() {
            let block = this.$formTool.blockData(this.$options.name)
            return block.meta && block.meta.canSkip == false ? false : true
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                // this.selected[0].value = moment(this.selected[0].value, 'YYYY-MM-DD').format('DD/MM/YYYY')
                this.nextBlock = await this.getNextBlock()
                this.emitChange()
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // Get api data
            this.data = [
                {
                    type: 'date',
                    min: moment().subtract(10, 'years').format('YYYY-MM-DD'),
                    max: moment().format('YYYY-MM-DD'),
                    value: this.selected ? this.selected[0].value : null,
                    required: !this.canSkip
                }
            ]
            
            this.loading = false
        },

        async end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            this.nextBlock = await this.getNextBlock()
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
        },

        async getNextBlock() {
            let requestBody = {
                id_app: this.$formTool.getFormData('device')[0].value.id,
                id_enseigne: this.$formTool.getFormData('sign').id,
                is_extension: false
            }
            if (this.$formTool.getFormData('purchase-date')[0].value) {
                requestBody.purchase_date = moment(this.$formTool.getFormData('purchase-date')[0].value, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            let onlineId = 0 // 0 -> no online card, 1: only online, 2: only shop
            if (this.$formTool.getFormData('buy-online')) {
                onlineId = this.$formTool.getFormData('buy-online') == 'online' ? 1 : 2
            }
            requestBody.online = onlineId
            requestBody.id_mag = this.$formTool.getFormData('shop') && this.$formTool.getFormData('shop')[0].value ? this.$formTool.getFormData('shop')[0].value.id : 1
            let response = await apiService.post('getproc', requestBody)
            let responseData = response.data.posts.post
            if (responseData.extension_garantie != 0) {
                return this.$formTool.blockData(this.$options.name).next.extensionWarranty
            }
            return this.$formTool.blockData(this.$options.name).next.folderWarranty
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/PurchaseDateCard.vue